import { createContext } from "react";

export default createContext(
  {} as Record<string, (...args: unknown[]) => unknown>
);
